import ManagementMailModal from "./managementMailModal";

export default ManagementMailModal;